/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Team_FullInputs */

const en_landing_team_full = /** @type {(inputs: Landing_Team_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No open times this week`)
};

const pl_landing_team_full = /** @type {(inputs: Landing_Team_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak wolnych terminów w tym tygodniu`)
};

/**
* | output |
* | --- |
* | "No open times this week" |
*
* @param {Landing_Team_FullInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_team_full = /** @type {((inputs?: Landing_Team_FullInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Team_FullInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_team_full(inputs)
	return en_landing_team_full(inputs)
});